import type { APCutoffTab, APJournalEntryRow } from './types';

const TAB_PATHS: Record<APCutoffTab, string> = {
  review: '/ap-cutoff-enforcer',
  exceptions: '/ap-cutoff-enforcer/exceptions',
  'journal-entry': '/ap-cutoff-enforcer/journal-entry',
  'source-data': '/ap-cutoff-enforcer/source-data',
  configuration: '/ap-cutoff-enforcer/configuration',
};

export function routeToAPCutoffTab(path: string): APCutoffTab {
  if (path.endsWith('/exceptions')) return 'exceptions';
  if (path.endsWith('/journal-entry')) return 'journal-entry';
  if (path.endsWith('/source-data')) return 'source-data';
  if (path.endsWith('/configuration')) return 'configuration';
  return 'review';
}

export function apCutoffTabToPath(tab: APCutoffTab): string {
  return TAB_PATHS[tab];
}

export function formatCurrency(value: number | null | undefined): string {
  return (value ?? 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
}

export function formatPercent(value: number | null | undefined): string {
  return `${Math.round((value ?? 0) * 100)}%`;
}

export function buildNetSuiteCsv(rows: APJournalEntryRow[]): string {
  const headers = [
    'External ID',
    'Date',
    'Memo',
    'Line',
    'Account',
    'Account Name',
    'Debit',
    'Credit',
    'Department',
    'Subsidiary',
    'Currency',
    'Line Memo',
  ];
  const body = rows.map(row => [
    row.external_id,
    row.date,
    row.memo,
    row.line,
    row.account,
    row.account_name,
    row.debit,
    row.credit,
    row.department,
    row.subsidiary,
    row.currency,
    row.line_memo,
  ]);
  return [headers, ...body].map(values => values.map(csvCell).join(',')).join('\n');
}

function csvCell(value: unknown): string {
  const text = value === null || value === undefined ? '' : String(value);
  return `"${text.replace(/"/g, '""')}"`;
}
